import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  toggle() {
    if (!this.hasContentTarget) return;
    const el = this.contentTarget;
    el.style.display = (el.style.display === "none" || el.style.display === "") ? "block" : "none";
  }
} 